import { IntroWidget } from "common/IntroWidget";
import { Card } from "common/styleguide/Card";
import { commonCTAs, commonMessages, Msg } from "lib/localization";
import { urls } from "lib/urls";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import { MiniListItemDetail } from "../DashboardElements";
import styles from "./RecentActivity.scss";

export class RecentActivity extends React.PureComponent {
  state = {
    showMore: false,
  };

  toggleMore = () => {
    this.setState({ showMore: !this.state.showMore });
  };

  render() {
    const { siteActivity } = this.props;
    const { showMore } = this.state;

    if (!siteActivity || siteActivity.length === 0) {
      return <Intro />;
    }

    const toShow = showMore ? 30 : 6;

    return (
      <Card className={styles.RecentActivity}>
        {siteActivity.slice(0, toShow).map((a) => (
          <SiteActivity key={a.id} a={a} />
        ))}
        {siteActivity.length > 6 &&
          (showMore ? (
            <a data-card-link onClick={this.toggleMore}>
              <Msg m={commonCTAs.showLess} />
            </a>
          ) : (
            <a data-card-link onClick={this.toggleMore}>
              <Msg m={commonCTAs.showMore} />
            </a>
          ))}
      </Card>
    );
  }
}

const getURLforActivity = (a) => {
  switch (a.actionableItemType) {
    case "Trip":
      return urls.trips.show(a.actionableItemId);
    case "Route":
      return urls.routes.show(a.actionableItemId);
    case "AmbassadorRoute":
      return urls.ambassadorRoutes.show(a.actionableItemId);
    default:
      return false;
  }
};

const SiteActivity = ({ a }) => {
  const url = getURLforActivity(a);
  return (
    <div className={styles.SiteActivity}>
      <div className={styles.name}>
        {url ? (
          <a href={url} target="_blank">
            {a.name}
          </a>
        ) : (
          a.name
        )}
      </div>
      <div className={styles.action}>
        <MiniListItemDetail>{a.action}</MiniListItemDetail>
      </div>
    </div>
  );
};

const Intro = () => (
  <Card className={styles.RecentActivity}>
    <IntroWidget
      i="md-eye"
      link={
        <a href="/find">
          <Msg m={commonMessages.getInspired} />
        </a>
      }
    >
      <T id="RecentActivity.intro" defaultMessage="Your recently viewed routes & rides will appear in this box." />
    </IntroWidget>
  </Card>
);
